import React, { useState } from 'react';
import Modal from './Modal';

// Inner pages and forms:
import StartPortfolio from '../pages/StartPortfolio';
import ClientPortal from '../pages/ClientPortal';
import PortfolioRegForm from './PortfolioRegForm';
import RegistrationForm from './RegistrationForm';
import LoginForm from './LoginForm';

export default function FrontPage() {
  const [isPortfolioModalOpen, setPortfolioModalOpen] = useState(false);
  const [isAccountModalOpen, setAccountModalOpen]     = useState(false);

  // Sub‑modals for StartPortfolio (unchanged)
  const [isPassCreateOpen, setPassCreateOpen] = useState(false);
  const [isPassLoginOpen, setPassLoginOpen]   = useState(false);

  // Sub‑modals for Client Portal
  const [isRegOpen, setRegOpen]               = useState(false);
  const [isAccLoginOpen, setAccLoginOpen]     = useState(false);

  return (
    <>
      <section className="homepage-top-banner section no-vertical-padding">
        <div className="container frontcontainer">
          <div className="columns is-multiline is-mobile is-variable is-2-mobile is-4-tablet">

            {/* — Talents Column → opens StartPortfolio modal — */}
            <div className="column is-12-mobile is-6-tablet">
              <div
                className="image-block top-banner-item rounded"
                style={{ paddingTop: '98.82352941176471%' }}
              >
                <img
                  alt="Go to Your Portfolio"
                  src="https://firebasestorage.googleapis.com/v0/b/flourishtalents1.appspot.com/o/public%2Fimages%2Fweblogo.png?alt=media&token=a6fe6e55-0807-4294-969b-e064bdee026c"
                  className="image-block-image"
                  width="768"
                  height="758"
                />
                <div className="image-block-inner">
                  <div className="top-banner-item-inner">
                    <h1 className="title">Talents</h1>
                    <p className="text-big">
                      Gain access to opportunities<br/>
                      to perform and represent.
                    </p>
                    <button
                      onClick={() => setPortfolioModalOpen(true)}
                      className="button primary is-medium is-rounded find-talentsspan-button fitbutton"
                    >
                      <span>Go to Your Portfolio</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* — Brands Column → opens Client Portal modal — */}
            <div className="column is-12-mobile is-6-tablet">
              <div
                className="image-block top-banner-item rounded blockspacing"
                style={{ paddingTop: '98.82352941176471%' }}
              >
                <img
                  alt="Go to Your Account"
                  src="https://firebasestorage.googleapis.com/v0/b/flourishtalents1.appspot.com/o/public%2Fimages%2Fnile%20bridge%20new%20yr%20lights.jpg?alt=media&token=a7933475-3b89-40c3-8534-c3ec11db97a3"
                  className="image-block-image"
                  width="768"
                  height="758"
                />
                <div className="image-block-inner">
                  <div className="top-banner-item-inner">
                    <h1 className="title">Brands</h1>
                    <p className="text-big">
                      Achieve greatness with our media,<br/>
                      creatives and brand ambassadors.
                    </p>
                    <button
                      onClick={() => setAccountModalOpen(true)}
                      className="button primary is-medium is-rounded find-offersspan-button fitbutton"
                    >
                      <span>Go to Your Account</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* — Portfolio Modal (wraps <StartPortfolio />) — */}
      <Modal
        isOpen={isPortfolioModalOpen}
        onClose={() => setPortfolioModalOpen(false)}
      >
    <div style={{ textAlign: 'center', padding: '1rem' }}>
      <h1>Showcase & Stand out</h1>
    </div>
        <StartPortfolio
          onCreate={() => setPassCreateOpen(true)}
          onLogin={()   => setPassLoginOpen(true)}
        />
      </Modal>

      {/* — StartPortfolio “Create Portfolio” sub‑modal — */}
      <Modal
        isOpen={isPassCreateOpen}
        onClose={() => setPassCreateOpen(false)}
      >
        <PortfolioRegForm closeModal={() => setPassCreateOpen(false)} />
      </Modal>

      {/* — StartPortfolio “Log In” sub‑modal — */}
      <Modal
        isOpen={isPassLoginOpen}
        onClose={() => setPassLoginOpen(false)}
        title="Secure Access Point"
      >
        <LoginForm onSuccess={() => setPassLoginOpen(false)} />
      </Modal>

      {/* — Client Portal main modal — */}
      <Modal
        isOpen={isAccountModalOpen}
        onClose={() => setAccountModalOpen(false)}
        title="Client Portal"
      >
        <ClientPortal
          onRegister={() => setRegOpen(true)}
          onLogin={()    => setAccLoginOpen(true)}
        />
      </Modal>

      {/* — Client‑Portal “Create Account” sub‑modal — */}
      <Modal
        isOpen={isRegOpen}
        onClose={() => setRegOpen(false)}
      >
        <RegistrationForm onSuccess={() => setRegOpen(false)} />
      </Modal>

      {/* — Client‑Portal “Log In” sub‑modal — */}
      <Modal
        isOpen={isAccLoginOpen}
        onClose={() => setAccLoginOpen(false)}
        title="Secure Access Point"
      >
        <LoginForm onSuccess={() => setAccountModalOpen(false)} />
      </Modal>
    </>
  );
}